import { history } from 'umi';
const removeJWTAndLang = (): void => {
  localStorage.removeItem(TOKEN_NAME);
  localStorage.removeItem(BUSINESS_OVERVIEW_STARTDATE);
  localStorage.removeItem(BUSINESS_OVERVIEW_ENDDATE);
  localStorage.removeItem('POLICYTABKEY');
  localStorage.removeItem('user_info');
  localStorage.removeItem('EMAILCOUNTDOWN');
  localStorage.removeItem('COUNTDOWN');
};

const logout = (): Promise<void> => {
  return new Promise((resolve) => {
    resolve(history.push('/login'));
    window.gtag('event', 'log_out', {
      success: true,
      user_unique_id: JSON.parse(localStorage.getItem('user_info') ?? '{}')?.id,
    });
    removeJWTAndLang();
  });
};

export default logout;
